export default "__VITE_ASSET__y353ai$t__"